module.exports = __webpack_public_path__ + "img/ServicesReservationsCalendar.fd5aa1c1.svg";